module.exports = __webpack_public_path__ + "/build/web/images/testimonials-right-1@2x.9a6cd617a15668160543d074f5739fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-right-1@2x.jpg
// module id = 201
// module chunks = 13